import { useTranslations } from "contexts/LocalizationContext";
import { Button } from "@chakra-ui/react";
import config from "config/config";
import type { LogInButtonProps } from "./LogInButton.d";

export const LogInButton = ({ labelKey = "button_login", ...props }: LogInButtonProps) => {
  const translations = useTranslations();
  return (
    <Button
      key="button_login"
      variant="primary"
      href={`${config.webappUrl}/plus`}
      ml={{ lg: 1, xl: 8 }}
      px={{ lg: 3, xl: 6 }}
      title={translations("button_login")}
      as="a"
      _visited={{}}
      data-testid="top-navbar-login-airhelp-plus"
      textAlign="center"
      width={{ base: "full", lg: "initial" }}
      {...props}
    >
      {translations(labelKey)}
    </Button>
  );
};
